import { INPUT_TYPE } from "../../constants/Constant";
import { INPUT_VIEW_DIRECTION } from "../SequenceNumberFormat/Other";

export const REHIRE_EMPLOYEE = [
    {
        key: "dateOfJoining",
        columnCode: "dateOfJoining",
        options: [],
        icon: "",
        validation: null,
        isValid: true,
        name: "Rehire Date",
        type: INPUT_TYPE.DATE,
        errorMessage: null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required: true,
        readOnly: false,
        uiVisible: true,
        tooltipText: "Please make sure the rehire date does not coincide with the employee’s service period.",
    },
    {
        key: "dateOfConfirmation",
        columnCode: "dateOfConfirmation",
        options: [],
        icon: "",
        validation: null,
        isValid: true,
        name: "Confirmation Date",
        type: INPUT_TYPE.DATE,
        errorMessage: null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required: true,
        readOnly: false,
        uiVisible: true,
        tooltipText: "Please make sure the confirmation date does not coincide with the employee’s service period.",
    },
];

export const TERMINATION_TYPE = [
	{ id: "VOLUNTARY", name: "Voluntary" },
	{ id: "INVOLUNTARY", name: "Involuntary" },
	{ id: "restructure", name: "Restructure" },
	{ id: "internalTransfer", name: "Internal Transfer" },
	{ id: "death", name: "Death" },
];

export const TERMINATION_REASONS = [
	{ id: "education", name: "Education" },
	{ id: "excessiveAbsenceTardy", name: "Excessive absence/tardy" },
	{ id: "grossMisconduct", name: "Gross Misconduct" },
	{ id: "lackOfWork", name: "Lack of work" },
	{ id: "laidOff", name: "Laid Off" },
	{ id: "moving", name: "Moving" },
	{ id: "mutualAgreement", name: "Mutual agreement" },
	{ id: "none", name: "None" },
	{ id: "otherJobBetterProspectus", name: "Other job/ Better Prospectus" },
	{ id: "performance", name: "Performance" },
	{ id: "personalFamily", name: "Personal/family" },
	{ id: "retirementEarlyRetire", name: "Retirement/Early Retire" },
	{ id: "temporaryJobEnded", name: "Temporary job ended" },
	{ id: "theft", name: "Theft" },
	{ id: "transferredOut", name: "Transferred out" },
	{ id: "absconding", name: "Absconding" },
];

export const INTERVIEW_FEEDBACK_OPTIONS = [
    { id: "yes", name: "Yes" },
    { id: "no", name: "No" }
];
